import React from "react";

export default function Loader({ message = "Loading HireKahani...", inline = false }) {
  return (
    <div style={{
      minHeight: inline ? '300px' : '100vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: inline ? 'transparent' : 'var(--bg)',
      zIndex: 2000,
      position: 'relative',
      overflow: 'hidden',
      padding: inline ? '40px 0' : 0
    }}>
      <style>{`
        @keyframes wipe {
          0% { transform: translateX(-60px) rotate(-10deg); opacity: 0; }
          20% { opacity: 1; }
          40% { transform: translateX(60px) rotate(10deg); opacity: 1; }
          60% { transform: translateX(-30px) rotate(-5deg); opacity: 1; }
          80% { transform: translateX(30px) rotate(5deg); opacity: 1; }
          100% { transform: translateX(120px) rotate(20deg); opacity: 0; }
        }

        @keyframes sparkle {
          0% { transform: scale(0) rotate(0deg); opacity: 0; }
          50% { transform: scale(1.2) rotate(180deg); opacity: 1; }
          100% { transform: scale(0) rotate(360deg); opacity: 0; }
        }

        @keyframes glassesSlide {
          0% { transform: translateY(0); }
          10% { transform: translateY(12px); }
          80% { transform: translateY(12px); }
          90% { transform: translateY(0); }
        }

        @keyframes floating {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.4; }
        }

        .glasses-container {
          position: relative;
          width: 120px;
          height: 120px;
          animation: floating 3s ease-in-out infinite;
        }

        .elephant-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        /* The simulated glasses cleaning cloth */
        .cleaning-cloth {
          position: absolute;
          top: 45%;
          left: 50%;
          width: 40px;
          height: 30px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          border: 1px solid var(--border);
          z-index: 10;
          animation: wipe 2.5s ease-in-out infinite;
        }

        /* Shine effect */
        .shine {
          position: absolute;
          top: 40%;
          left: 60%;
          color: gold;
          font-size: 24px;
          z-index: 11;
          animation: sparkle 2.5s ease-in-out infinite;
          animation-delay: 1.5s;
        }

        .shine-2 {
          position: absolute;
          top: 48%;
          left: 35%;
          color: gold;
          font-size: 18px;
          z-index: 11;
          animation: sparkle 2.5s ease-in-out infinite;
          animation-delay: 1.7s;
        }
      `}</style>
      
      <div className="glasses-container">
        <img src="/logo-mascot.png" className="elephant-img" alt="Elephant Mascot" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
      </div>


      <div style={{ 
        marginTop: 24, 
        fontFamily: 'var(--display)', 
        color: 'var(--text2)', 
        fontSize: 15, 
        fontWeight: 700,
        letterSpacing: -0.2,
        animation: 'pulse 1.5s infinite' 
      }}>
        {message}
      </div>
      
      {!inline && (
        <div style={{ 
          marginTop: 8, 
          fontSize: 12, 
          color: 'var(--text3)', 
          fontWeight: 500,
          opacity: 0.8
        }}>
          Polishing the lenses for your kahanis...
        </div>
      )}
    </div>
  );
}
